import { SUPPORTED_LANGUAGES } from '@/i18n/config';

export const primaryLanguageCode = (code) => {
  if (!code) return '';
  return String(code).split('-')[0].trim().toLowerCase();
};

export const languageFlagMeta = (code) => {
  const primary = primaryLanguageCode(code);
  return SUPPORTED_LANGUAGES.find((language) => language.code === primary) || null;
};